// ProductManagement.js
import React, { useState, useRef, useEffect, useContext } from 'react';
import { Row, Col, Form, Spinner } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import AppContext from '../../../../context/AppContext';
import '../../../../assests/css/admin/ProductManagement/ProductManagement.css';

const getStatusClass = (status) => {
  if (status === 'In Stock') return 'AdminProductManagement-status-in';
  if (status === 'Low Stock') return 'AdminProductManagement-status-low';
  if (status === 'Out of Stock') return 'AdminProductManagement-status-out';
  return '';
};

const ProductManagement = () => {

  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  const [view, setView] = useState('list');
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubcategory, setSelectedSubcategory] = useState('all');
  const [stockFilter, setStockFilter] = useState('all');
  const [priceFilter, setPriceFilter] = useState('all');
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState([]);
  const [name, setName] = useState('');
  const [productId, setProductId] = useState();
  const [sku, setSku] = useState('');
  const [barcode, setBarcode] = useState('');
  const [description, setDescription] = useState('');
  const [basePrice, setBasePrice] = useState('');

  const [sizes, setSizes] = useState('');
  const [colors, setColors] = useState([]);
  const [colorSelectorValue, setColorSelectorValue] = useState("#000000");
  const [images, setImages] = useState([]);
  const [variants, setVariants] = useState([]);
  const [tags, setTags] = useState([]);
  const [isActive, setIsActive] = useState(true);
  const [brand, setBrand] = useState('');
  const [quantity, setQuantity] = useState('');
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [newTag, setNewTag] = useState('');
  const [newSize, setNewSize] = useState('');
  const [newColor, setNewColor] = useState('');
  const [productType, setProductType] = useState('stitched');
  const [showOnHome, setShowOnHome] = useState(false);
  const fileInputRef = useRef(null);
  const textareaRef = useRef(null);
  const [errors, setErrors] = useState({});

  // ── Validate function
  const validateForm = () => {
    const newErrors = {};
    if (!name.trim()) newErrors.name = 'Must enter the product name';
    if (!sku.trim()) newErrors.sku = 'Enter the SKU';
    if (!description.trim()) newErrors.description = 'Add Description';
    if (!basePrice || isNaN(basePrice) || parseFloat(basePrice) <= 0)
      newErrors.basePrice = 'Enter base price';
    // Sale ab sirf banner system (MlSaleController) control karta hai — form se koi validation nahi
    if (!sizes || !sizes.toString().trim()) newErrors.sizes = 'Write the Size';
    if (colors.length === 0) newErrors.colors = 'Add Color';
    if (!quantity || isNaN(quantity) || parseInt(quantity) < 0)
      newErrors.quantity = 'Add Stock quantity';
    if (!selectedCategory) newErrors.selectedCategory = 'Select Category';
    if (!selectedSubcategory || selectedSubcategory === 'all')
      newErrors.selectedSubcategory = 'Sub-Select Category';
    if (images.length === 0) newErrors.images = 'Select atleast image';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const viewproduct = () => {
    setLoading(true);
    axios.get(`${baseUrl}/admin/product/viewproduct`)
      .then((response) => {
        console.log(response.data);
        setProduct(response.data.products || []);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const viewAllCategories = () => {
    setLoading(true);
    axios.get(`${baseUrl}/admin/category/getAllCategories`)
      .then((response) => {
        console.log(response.data);
        setCategories(response.data.data || []);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const getAllSubcategory = (cat_id) => {
    const formdata = new FormData();
    formdata.append("mlcategory_id", cat_id);
    axios.post(`${baseUrl}/admin/subcategory/getAllSubcategories`, formdata, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((response) => {
        console.log(response.data);
        setSubcategories(response.data.data || []);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // ── ADD PRODUCT
  const createproduct = () => {
    if (!validateForm()) return;
    const formdata = new FormData();
    formdata.append('name', name);
    formdata.append('sku', sku);
    formdata.append('type', productType);
    formdata.append('show_on_home', showOnHome ? 1 : 0);
    formdata.append('barcode', barcode);
    formdata.append('description', description);
    formdata.append('base_price', basePrice);
    formdata.append('sizes', sizes);
    formdata.append('colors', colors.join(","));
    images.forEach((img) => { formdata.append("images[]", img.file); });
    formdata.append('tags', tags);
    formdata.append('status', isActive ? 'active' : 'inactive');
    formdata.append('brand', brand);
    formdata.append('stock_quantity', quantity);
    formdata.append('mlcategory_id', selectedCategory);
    formdata.append('mlsubcategory_id', selectedSubcategory);

    axios.post(`${baseUrl}/admin/product/createproduct`, formdata, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          Swal.fire({
            icon: 'success',
            title: 'Product Added!',
            text: ' product add successfully ',
            confirmButtonColor: '#3085d6',
          });
          viewproduct();
          setView('list');
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({ icon: 'error', title: 'Error!', text: 'Product add karne mein masla aaya.' });
      });
  };

  // ── UPDATE PRODUCT
  const updateproduct = () => {
    // if (!validateForm()) return;
    const formdata = new FormData();
    formdata.append('name', name);
    formdata.append('productId', productId);
    formdata.append('type', productType);
    formdata.append('show_on_home', showOnHome ? 1 : 0);
    formdata.append('sku', sku);
    formdata.append('barcode', barcode);
    formdata.append('description', description);
    formdata.append('base_price', basePrice);
    formdata.append('sizes', sizes);
    formdata.append('colors', colors.join(","));
    // ── FIX: only send images that are newly uploaded (skip existing ones loaded from DB)
    images.forEach((img) => { if (img.file) formdata.append("images[]", img.file); });
    formdata.append('tags', tags);
    formdata.append('status', isActive ? 'active' : 'inactive');
    formdata.append('brand', brand);
    formdata.append('stock_quantity', quantity);
    formdata.append('mlcategory_id', selectedCategory);
    formdata.append('mlsubcategory_id', selectedSubcategory);

    axios.post(`${baseUrl}/admin/product/updateproduct`, formdata, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((response) => {
        console.log(response.data);
        if (response.data.success) {
          Swal.fire({
            icon: 'success',
            title: 'Product Updated!',
            text: 'Product  successfully update ',
            confirmButtonColor: '#3085d6',
          });
          viewproduct();
          setView('list');
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({ icon: 'error', title: 'Error!', text: 'Product can not be update .' });
      });
  };

  // ── DELETE PRODUCT — SweetAlert2 confirm ke saath
  const deleteproduct = (pid) => {
    Swal.fire({
      title: 'Are you Sure?',
      text: 'Your product is permanently delete',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'are u sure!',
      cancelButtonText: 'cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        const formdata = new FormData();
        formdata.append('productId', pid);
        axios.post(`${baseUrl}/admin/product/deleteproduct`, formdata, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
          .then((response) => {
            console.log(response.data);
            if (response.data.success) {
              Swal.fire({
                icon: 'success',
                title: 'Delete!',
                text: 'Product successfully',
                confirmButtonColor: '#3085d6',
              });
              viewproduct();
              setView('list');
            } else {
              Swal.fire({ icon: 'error', title: 'Error!', text: 'Product wont be delete.' });
            }
          })
          .catch((error) => {
            console.log(error);
            Swal.fire({ icon: 'error', title: 'Error!', text: 'Server issue, try again' });
          });
      }
    });
  };

  useEffect(() => {
    viewAllCategories();
    viewproduct();
  }, []);

  const resetAddStates = () => {
    setName(''); setSku(''); setBarcode(''); setDescription('');
    setBasePrice('');
    setSizes(''); setColors([]);
    setProductType('stitched');
    setShowOnHome(false);
    setImages([]); setVariants([]); setTags([]);
    setIsActive(true); setBrand(''); setQuantity('');
    setSelectedCategory(''); setSelectedSubcategory('all');
    setErrors({});
  };

  const openAdd = () => {
    resetAddStates();
    setView('add');
  };

  const openEdit = (prod) => {
    setSelectedProduct(prod);
    setProductId(prod.id);
    setProductType(prod.type || 'stitched');
    setShowOnHome(!!prod.show_on_home);
    setName(prod.name || '');
    setSku(prod.sku || '');
    setBarcode(prod.barcode || '');
    setDescription(prod.description || '');
    setBasePrice(prod.base_price || prod.price || '');
    // ── FIX: sizes/colors live on prod.variant (Mlproductvarient), not directly on prod
    setSizes(prod.variant?.sizes || prod.sizes || '');
    setColors(
      prod.variant?.colors && prod.variant.colors.trim() !== ''
        ? prod.variant.colors.split(",").filter(c => c.trim() !== '')
        : (prod.colors && prod.colors.trim() !== ''
            ? prod.colors.split(",").filter(c => c.trim() !== '')
            : [])
    );
    // ── FIX: load existing gallery images so they show in edit mode instead of being cleared
    setImages(
      (prod.images || []).map((img, idx) => ({
        id: img.id,
        file: null, // ── null marks this as an existing image, not a new upload
        preview: `${baseUrlForFiles}/${img.image_path}`,
        name: img.image_path,
        isMain: idx === 0,
        existing: true,
      }))
    );
    setVariants([]);
    // ── FIX: tags undefined ho toh empty array
    setTags(
      prod.tags && prod.tags.trim() !== ''
        ? prod.tags.split(',').filter(t => t.trim() !== '')
        : []
    );
    setIsActive(prod.is_active !== undefined ? prod.is_active : true);
    setBrand(prod.brand || '');
    setQuantity(prod.stock_quantity || '');
    setSelectedCategory(prod.mlcategory_id || '');
    if (prod.mlcategory_id) getAllSubcategory(prod.mlcategory_id);
    setSelectedSubcategory(prod.mlsubcategory_id || '');
    setErrors({});
    setView('edit');
  };

  const stats = {
    total: product.length,
    lowStock: product.filter(p => p.stock_quantity > 0 && p.stock_quantity <= 10).length,
    outOfStock: product.filter(p => p.stock_quantity === 0).length,
    topCategory: 'Women',
  };

  const handleCategoryChange = (cat) => {
    setSelectedCategory(cat);
    setSelectedSubcategory('all');
    setSearchTerm('');
    setStockFilter('all');
    setPriceFilter('all');
  };

  const applyFormat = (format) => {
    const ta = textareaRef.current;
    if (!ta) return;
    const s = ta.selectionStart, e = ta.selectionEnd;
    const sel = description.substring(s, e);
    if (!sel) return;
    const map = {
      bold: `**${sel}**`, italic: `*${sel}*`,
      underline: `__${sel}__`, bullet: `\n• ${sel}`, numbered: `\n1. ${sel}`,
    };
    if (format === 'link') {
      const u = prompt('Enter URL:');
      if (u) setDescription(description.substring(0, s) + `[${sel}](${u})` + description.substring(e));
      return;
    }
    setDescription(description.substring(0, s) + (map[format] || sel) + description.substring(e));
  };

  const handleImageUpload = (ev) => {
    const files = Array.from(ev.target.files);
    const imgs = files.map(f => ({
      id: Date.now() + Math.random(), file: f,
      preview: URL.createObjectURL(f), name: f.name, isMain: images.length === 0,
    }));
    setImages(prev => [...prev, ...imgs]);
  };

  const removeImage = (imgId) => {
    setImages(prev => {
      const upd = prev.filter(i => i.id !== imgId);
      if (upd.length > 0 && prev.find(i => i.id === imgId)?.isMain) upd[0].isMain = true;
      return upd;
    });
  };

  const setMainImage = (imgId) =>
    setImages(prev => prev.map(i => ({ ...i, isMain: i.id === imgId })));

  const addTag = () => { if (newTag && !tags.includes(newTag)) { setTags([...tags, newTag]); setNewTag(''); } };
  const removeTag = (t) => setTags(tags.filter(x => x !== t));

  const addSize = () => { if (newSize && !sizes.includes(newSize)) { setSizes([...sizes, newSize]); setNewSize(''); } };
  const removeSize = (s) => setSizes(sizes.filter(x => x !== s));

  const addColor = () => { if (!colors.find(c => c === newColor)) { setColors([...colors, newColor]); setNewColor('#000000'); } };
  const removeColor = (n) => setColors(colors.filter(c => c.name !== n));

  const addVariant = () => { if (sizes.length > 0 && colors.length > 0) setVariants([...variants, { size: sizes[0], color: colors[0].name, stock: 0, priceOverride: null }]); };
  const removeVariant = (i) => setVariants(variants.filter((_, idx) => idx !== i));
  const updateVariant = (i, field, val) => { const v = [...variants]; v[i] = { ...v[i], [field]: val }; setVariants(v); };

  return (
    <div className="AdminProductManagement-wrapper">

      <div className="AdminProductManagement-top-header">
        <div>
          <h1 className="AdminProductManagement-page-title">
            {view === 'list' ? 'Product Management' : view === 'add' ? 'Add New Product' : `Edit Product: ${selectedProduct?.name}`}
          </h1>
          <p className="AdminProductManagement-page-sub">
            {view === 'list' ? 'Manage your catalog across all categories.'
              : view === 'add' ? 'Create a new product with details, pricing, and media.'
                : 'Manage product details, pricing, and media.'}
          </p>
        </div>
        {view === 'list' && (
          <button className="AdminProductManagement-btn-add" onClick={openAdd}>+ Add Product</button>
        )}
      </div>

      {view === 'list' && (
        <>
          <Row className="AdminProductManagement-stats-row g-3 mb-3">
            {[
              { icon: '📦', label: 'TOTAL PRODUCTS', value: stats.total },
              { icon: '⚠️', label: 'LOW STOCK', value: stats.lowStock },
              { icon: '🛒', label: 'OUT OF STOCK', value: stats.outOfStock },
              { icon: '✅', label: 'TOP CATEGORY', value: stats.topCategory },
            ].map((s, i) => (
              <Col key={i} xs={12} sm={6} lg={3}>
                <div className="AdminProductManagement-stat-card">
                  <span className="AdminProductManagement-stat-icon">{s.icon}</span>
                  <div>
                    <div className="AdminProductManagement-stat-label">{s.label}</div>
                    <div className="AdminProductManagement-stat-value">{s.value}</div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          <Row className="AdminProductManagement-filters-row align-items-center mb-3 g-2">
            <Col xs={12} md={4}>
              <div className="AdminProductManagement-search-box">
                <span className="AdminProductManagement-search-icon">🔍</span>
                <input
                  className="AdminProductManagement-search-input"
                  placeholder="Search by name, SKU, or tag..."
                  value={searchTerm}
                  onChange={e => setSearchTerm(e.target.value)}
                />
              </div>
            </Col>
            <Col xs={6} md={2}>
              <Form.Select className="AdminProductManagement-select" value={selectedCategory} onChange={e => handleCategoryChange(e.target.value)}>
                <option value="women">Women</option>
                <option value="men">Men</option>
                <option value="kids">Kids</option>
                <option value="accessories">Accessories</option>
              </Form.Select>
            </Col>
            <Col xs={6} md={2}>
              <Form.Select className="AdminProductManagement-select" value={stockFilter} onChange={e => setStockFilter(e.target.value)}>
                <option value="all">Stock Status</option>
                <option value="in-stock">In Stock</option>
                <option value="low-stock">Low Stock</option>
                <option value="out-of-stock">Out of Stock</option>
              </Form.Select>
            </Col>
            <Col xs={6} md={2}>
              <Form.Select className="AdminProductManagement-select" value={priceFilter} onChange={e => setPriceFilter(e.target.value)}>
                <option value="all">Price Range</option>
                <option value="under-50">Under 50</option>
                <option value="50-100">50 – 100</option>
                <option value="100-200">100 – 200</option>
                <option value="over-200">Over 200</option>
              </Form.Select>
            </Col>
          </Row>

          <div className="AdminProductManagement-tabs mb-2">
            {['women', 'men', 'kids', 'accessories'].map(cat => (
              <button key={cat}
                className={`AdminProductManagement-tab ${selectedCategory === cat ? 'AdminProductManagement-tab-active' : ''}`}
                onClick={() => handleCategoryChange(cat)}>
                {cat.charAt(0).toUpperCase() + cat.slice(1)}
              </button>
            ))}
          </div>

          <div className="AdminProductManagement-pills mb-3"></div>

          <div className="AdminProductManagement-table-wrapper">
            <table className="AdminProductManagement-table">
              <thead>
                <tr>
                  <th>PRODUCT IMAGE</th>
                  <th>PRODUCT DESCRIPTION</th>
                  <th>PRICE</th>
                  <th>STOCK STATUS</th>
                  <th>ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="5" className="text-center py-4">
                      <Spinner animation="border" size="sm" />
                      <span className="ms-2">Loading...</span>
                    </td>
                  </tr>
                )}
                {!loading && product.map(prod => (
                  <tr key={prod.id}>
                    <td>
                      {prod.images && prod.images.length > 0 ? (
                        <img
                          src={`${baseUrlForFiles}/${prod.images[0]?.image_path}`}
                          alt={prod.name}
                          className="AdminProductManagement-product-img"
                        />
                      ) : (
                        <span className="AdminProductManagement-no-img">No Image</span>
                      )}
                    </td>
                    <td>
                      <div className="AdminProductManagement-product-name">{prod.name}</div>
                      <div className="AdminProductManagement-product-sku">SKU: {prod.sku}</div>
                      <span className="AdminProductManagement-subcat-badge">
                        {prod.subcategory?.title?.toUpperCase()}
                      </span>
                      {prod.show_on_home ? (
                        <span className="AdminProductManagement-subcat-badge" style={{ marginLeft: 6, background: '#e6f4ea', color: '#1e7e34' }}>
                          HOME
                        </span>
                      ) : null}
                    </td>
                    <td>
                      <span>{parseFloat(prod.base_price || prod.price || 0).toFixed(2)}</span>
                    </td>
                    <td>
                      <span className={`AdminProductManagement-status-badge ${getStatusClass(
                        prod.stock_quantity === 0 ? 'Out of Stock'
                          : prod.stock_quantity <= 10 ? 'Low Stock' : 'In Stock'
                      )}`}>
                        {prod.stock_quantity === 0 ? 'Out of Stock'
                          : prod.stock_quantity <= 10 ? 'Low Stock' : 'In Stock'}
                        ({prod.stock_quantity})
                      </span>
                    </td>
                    <td>
                      <div className="AdminProductManagement-actions">
                        <button
                          className="AdminProductManagement-btn-icon AdminProductManagement-btn-edit"
                          onClick={() => openEdit(prod)}
                          title="Edit">✏️</button>
                        <button
                          className="AdminProductManagement-btn-icon AdminProductManagement-btn-delete"
                          onClick={() => deleteproduct(prod.id)}
                          title="Delete">🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
                {!loading && product.length === 0 && (
                  <tr>
                    <td colSpan="5" className="AdminProductManagement-empty">
                      <div>📦</div>
                      <p>No product found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </>
      )}

      {(view === 'add' || view === 'edit') && (
        <div className="AdminProductManagement-form-layout">
          <div className="AdminProductManagement-form-main">

            {/* General Info */}
            <div className="AdminProductManagement-section">
              <h3 className="AdminProductManagement-section-title">ℹ️ General Information</h3>
              <Form.Label className="AdminProductManagement-label">Product Name *</Form.Label>
              <Form.Control type="text" className={`AdminProductManagement-input mb-1 ${errors.name ? 'is-invalid' : ''}`}
                placeholder="e.g. Premium Cotton T-Shirt"
                value={name} onChange={e => { setName(e.target.value); setErrors(prev => ({ ...prev, name: '' })); }} />
              {errors.name && <div className="text-danger small mb-2">{errors.name}</div>}

              <Row className="g-3">
                <Col sm={6}>
                  <Form.Label className="AdminProductManagement-label">SKU</Form.Label>
                  <Form.Control type="text" className={`AdminProductManagement-input ${errors.sku ? 'is-invalid' : ''}`}
                    placeholder="e.g. SHRT-102"
                    value={sku} onChange={e => { setSku(e.target.value); setErrors(prev => ({ ...prev, sku: '' })); }} />
                  {errors.sku && <div className="text-danger small">{errors.sku}</div>}
                </Col>
                <Col sm={6}>
                  <Form.Label className="AdminProductManagement-label">
                    {view === 'add' ? 'Barcode' : 'Brand'}
                  </Form.Label>
                  <Form.Control type="text" className="AdminProductManagement-input"
                    placeholder={view === 'add' ? 'ISBN/GTIN' : 'Enter brand name'}
                    value={view === 'add' ? barcode : brand}
                    onChange={e => view === 'add' ? setBarcode(e.target.value) : setBrand(e.target.value)} />
                </Col>
              </Row>
            </div>

            {/* Pricing */}
            <div className="AdminProductManagement-section">
              <h3 className="AdminProductManagement-section-title">💰 Pricing</h3>
              <Row className="g-3 mb-3">
                <Col sm={6}>
                  <Form.Label className="AdminProductManagement-label">Base Price *</Form.Label>
                  <Form.Control type="number" className={`AdminProductManagement-input ${errors.basePrice ? 'is-invalid' : ''}`}
                    placeholder="0.00" value={basePrice}
                    onChange={e => { setBasePrice(e.target.value); setErrors(prev => ({ ...prev, basePrice: '' })); }}
                    step="0.01" min="0" />
                  {errors.basePrice && <div className="text-danger small">{errors.basePrice}</div>}
                </Col>
              </Row>
              <p className="AdminProductManagement-muted">
                Sale pricing Sale Banner Management se control hoti hai — category pe banner lagane se yahan discount khud-b-khud apply hota hai.
              </p>
            </div>

            {/* Description */}
            <div className="AdminProductManagement-section">
              <h3 className="AdminProductManagement-section-title">📄 Description</h3>
              <div className="AdminProductManagement-toolbar">
                {[['bold', 'B'], ['italic', 'I'], ['underline', 'U'], ['bullet', '≡'], ['numbered', '≡'], ['link', '🔗']].map(([fmt, lbl]) => (
                  <button key={fmt} type="button" className="AdminProductManagement-toolbar-btn" onClick={() => applyFormat(fmt)}>{lbl}</button>
                ))}
              </div>
              <textarea ref={textareaRef} className={`AdminProductManagement-textarea ${errors.description ? 'is-invalid' : ''}`} rows={8}
                placeholder="Type your product description here..."
                value={description} onChange={e => { setDescription(e.target.value); setErrors(prev => ({ ...prev, description: '' })); }} />
              {errors.description && <div className="text-danger small">{errors.description}</div>}
            </div>

            {/* Media Gallery */}
            <div className="AdminProductManagement-section">
              <h3 className="AdminProductManagement-section-title">📷 Media Gallery</h3>
              <input ref={fileInputRef} type="file" accept="image/*" multiple
                onChange={handleImageUpload} style={{ display: 'none' }} />
              <div className="AdminProductManagement-media-grid">
                {images.map(img => (
                  <div key={img.id}
                    className={`AdminProductManagement-media-item ${img.isMain ? 'AdminProductManagement-media-main' : ''}`}
                    onClick={() => setMainImage(img.id)}>
                    <img src={img.preview} alt={img.name} />
                    {img.isMain && <span className="AdminProductManagement-media-badge">MAIN</span>}
                    <button type="button" className="AdminProductManagement-media-remove"
                      onClick={e => { e.stopPropagation(); removeImage(img.id); }}>×</button>
                  </div>
                ))}
                <div className="AdminProductManagement-media-item AdminProductManagement-media-add"
                  onClick={() => fileInputRef.current?.click()}>
                  <div>📁</div><div>Add Image</div>
                </div>
              </div>
              {errors.images && <div className="text-danger small mt-1">{errors.images}</div>}
            </div>

            {/* Variants */}
            <div className="AdminProductManagement-section">
              <div className="AdminProductManagement-section-header">
                <h3 className="AdminProductManagement-section-title">🎨 Variants</h3>
              </div>
              <Form.Label className="AdminProductManagement-label">Sizes Available</Form.Label>
              <Form.Control type='text' className={errors.sizes ? 'is-invalid' : ''}
                value={sizes} onChange={(event) => { setSizes(event.target.value); setErrors(prev => ({ ...prev, sizes: '' })); }} />
              {errors.sizes && <div className="text-danger small">{errors.sizes}</div>}

              <Form.Label className="AdminProductManagement-label mt-2">Colors Available</Form.Label>
              <div>
                <input type='color' value={colorSelectorValue} onChange={(e) => setColorSelectorValue(e.target.value)} />
                <input type='button' className='btn btn-primary mx-3' value="+"
                  onClick={() => { setColors([...colors, colorSelectorValue]); setErrors(prev => ({ ...prev, colors: '' })); }} />
                {typeof colors === 'object' ? colors.map((c, i) => (
                  <span key={i} style={{ display: 'inline-block', height: 20, margin: 5, borderRadius: "100%", width: 20, backgroundColor: c }} />
                )) : null}
              </div>
              {errors.colors && <div className="text-danger small">{errors.colors}</div>}

              {variants.length > 0 && (
                <div className="AdminProductManagement-table-wrapper">
                  <table className="AdminProductManagement-table">
                    <thead><tr><th>Size</th><th>Color</th><th>Stock</th><th>Price Override</th><th>Actions</th></tr></thead>
                    <tbody></tbody>
                  </table>
                </div>
              )}
            </div>

            {/* Inventory */}
            <div className="AdminProductManagement-section">
              <h3 className="AdminProductManagement-section-title">📦 Inventory</h3>
              <Form.Label className="AdminProductManagement-label">Quantity in Stock</Form.Label>
              <Form.Control type="number" className={`AdminProductManagement-input ${errors.quantity ? 'is-invalid' : ''}`}
                placeholder="0" value={quantity}
                onChange={e => { setQuantity(e.target.value); setErrors(prev => ({ ...prev, quantity: '' })); }} min="0" />
              {errors.quantity && <div className="text-danger small">{errors.quantity}</div>}
            </div>
          </div>

          {/* ── SIDEBAR ── */}
          <div className="AdminProductManagement-form-sidebar">

            <div className="AdminProductManagement-sidebar-section">
              <h3 className="AdminProductManagement-sidebar-title">🔄 Status</h3>
              <div className="AdminProductManagement-toggle-row">
                <div>
                  <div className="AdminProductManagement-label">{isActive ? 'Active' : 'Inactive'}</div>
                  <div className="AdminProductManagement-muted">
                    {isActive ? 'Will be visible in store' : 'Will be hidden from store'}
                  </div>
                </div>
                <label className="AdminProductManagement-toggle">
                  <input type="checkbox" checked={isActive} onChange={e => setIsActive(e.target.checked)} />
                  <span className="AdminProductManagement-toggle-slider"></span>
                </label>
              </div>
            </div>

            {/* ── Show on Home Page toggle ── */}
            <div className="AdminProductManagement-sidebar-section">
              <h3 className="AdminProductManagement-sidebar-title">🏠 Home Page</h3>
              <div className="AdminProductManagement-toggle-row">
                <div>
                  <div className="AdminProductManagement-label">Show on Home Page</div>
                  <div className="AdminProductManagement-muted">
                    {showOnHome
                      ? 'Ye product Home page pe bhi dikhega'
                      : 'Sirf category page pe dikhega, Home pe nahi'}
                  </div>
                </div>
                <label className="AdminProductManagement-toggle">
                  <input type="checkbox" checked={showOnHome} onChange={e => setShowOnHome(e.target.checked)} />
                  <span className="AdminProductManagement-toggle-slider"></span>
                </label>
              </div>
            </div>

            <div className="AdminProductManagement-sidebar-section">
              <Form.Label className="AdminProductManagement-label">Product Type *</Form.Label>
              <Form.Select
                className="AdminProductManagement-select mb-3"
                value={productType}
                onChange={e => setProductType(e.target.value)}
              >
                <option value="stitched">Stitched — Try On</option>
                <option value="unstitched">Unstitched — Customize</option>
              </Form.Select>
              <h3 className="AdminProductManagement-sidebar-title">🏷️ Organization</h3>
              <Form.Label className="AdminProductManagement-label">Category *</Form.Label>
              <Form.Select className={`AdminProductManagement-select mb-1 ${errors.selectedCategory ? 'is-invalid' : ''}`}
                value={selectedCategory} onChange={(e) => {
                  setSelectedCategory(e.target.value);
                  getAllSubcategory(e.target.value);
                  setErrors(prev => ({ ...prev, selectedCategory: '' }));
                }}>
                <option value="">Select Category</option>
                {categories.map((singleCategory) => (
                  <option key={singleCategory.id} value={singleCategory.id}>{singleCategory.category_name}</option>
                ))}
              </Form.Select>
              {errors.selectedCategory && <div className="text-danger small mb-2">{errors.selectedCategory}</div>}

              <Form.Select className={`AdminProductManagement-select mb-1 ${errors.selectedSubcategory ? 'is-invalid' : ''}`}
                value={selectedSubcategory} onChange={e => { setSelectedSubcategory(e.target.value); setErrors(prev => ({ ...prev, selectedSubcategory: '' })); }}>
                <option value="">Select Sub-category</option>
                {subcategories.map((sub) => (
                  <option key={sub.id} value={sub.id}>{sub.title}</option>
                ))}
              </Form.Select>
              {errors.selectedSubcategory && <div className="text-danger small mb-2">{errors.selectedSubcategory}</div>}

              <Form.Label className="AdminProductManagement-label">Tags</Form.Label>
              <div className="AdminProductManagement-tags mb-2">
                {tags.map((t, i) => (
                  <span key={i} className="AdminProductManagement-tag">
                    {t}
                    <button type="button" onClick={() => removeTag(t)} className="AdminProductManagement-tag-remove">×</button>
                  </span>
                ))}
              </div>
              <div className="AdminProductManagement-tag-input-row">
                <input type="text" placeholder="Type & enter..." className="AdminProductManagement-input-sm"
                  value={newTag} onChange={e => setNewTag(e.target.value)}
                  onKeyPress={e => e.key === 'Enter' && (e.preventDefault(), addTag())} />
                <button type="button" className="AdminProductManagement-tag-add-btn" onClick={addTag}>+</button>
              </div>
            </div>

            {view === 'edit' && selectedProduct && (
              <div className="AdminProductManagement-sidebar-section AdminProductManagement-danger-zone">
                <h3 className="AdminProductManagement-sidebar-title">⚠️ Danger Zone</h3>
                <p className="AdminProductManagement-danger-text">
                  Deleting this product will remove it permanently. This action cannot be undone.
                </p>
                <button type="button" className="AdminProductManagement-btn-danger"
                  onClick={() => deleteproduct(selectedProduct.id)}>
                  🗑️ Delete Product
                </button>
              </div>
            )}
          </div>

          {/* ── SAVE / CANCEL BUTTONS — NEECHE WITH PROPER SPACING ── */}
          <div className="AdminProductManagement-bottom-actions">
            <button
              className="AdminProductManagement-btn-cancel"
              style={{ marginRight: '16px' }}
              onClick={() => setView('list')}>
              Cancel
            </button>
            <button
              className="btn btn-primary px-4"
              onClick={view === 'add' ? createproduct : updateproduct}>
              💾 {view === 'add' ? 'Save Product' : 'Save Changes'}
            </button>
          </div>

        </div>
      )}
    </div>
  );
};

export default ProductManagement;